import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from "@angular/core";
import { UploadService } from "../../../../infrastructure/upload/upload-service";
import { Logger } from "../../../../infrastructure/logger";

@Component({
  selector: "icn-drag-image",
  templateUrl: "./drag-image.component.html",
  styleUrls: ["drag-image.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    "[class.empty]": "!(isUploading() || hasImage())",
    "[class.uploading]": "isUploading()",
    "[class.has-image]": "hasImage()",
  },
})
export class DragImageComponent {
  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private uploadService: UploadService,
    private logger: Logger,
  ) {}

  @Input()
  thumbnail: string;

  @Output()
  thumbnailChange = new EventEmitter<string>();

  dragging = false;
  uploading = false;

  hasImage() {
    return !!this.thumbnail;
  }

  isUploading() {
    return this.uploading;
  }

  onDrop(e) {
    if (e.dataTransfer.files.length === 0) {
      return;
    }

    this.dragging = false;
    this.changeDetectorRef.markForCheck();
    e.preventDefault();

    this.uploadImage(e.dataTransfer.files[0]);
  }

  onInputFileChange(e) {
    if (e.target.files.length === 0) {
      return;
    }

    this.uploadImage(e.target.files[0]);
    e.target.value = "";
  }

  uploadImage(file: File) {
    if (this.uploading) {
      return;
    }
    this.uploading = true;
    this.setThumbnail(undefined);

    this.uploadService
      .uploadSmallFile(file)
      .then((url) => {
        this.setThumbnail(url);
        this.uploading = false;
        this.changeDetectorRef.markForCheck();
      })
      .catch((err) => {
        this.logger.warn("Could not upload file. Error: " + err);
        this.uploading = false;
        this.changeDetectorRef.markForCheck();
      });
  }

  onDragEnter() {
    this.dragging = true;
  }

  onDragLeave() {
    this.dragging = false;
  }

  setThumbnail(val) {
    this.thumbnail = val;
    this.thumbnailChange.emit(val);
  }
}
